export enum ClientDataConstants {
  SET_CLIENT_DATA = 'clientData/SET_CLIENT_DATA',
  SET_CLIENT_DATA_IMPORT_ERROR = 'clientData/SET_CLIENT_DATA_IMPORT_ERROR',
  ON_CLIENT_DATA_IMPORT_SUCCESS = 'clientData/ON_CLIENT_DATA_IMPORT_SUCCESS',
}
